import {EntityService} from 'src/service/EntityService';

export class CustomerService extends EntityService {

  static entity = 'iam-party/customers';

  static find(term: string): Promise<any> {
    return this.axios.get(`${this.entity}/find`, {params: {term}}).then(res => res.data);
  }

}